import axios from 'axios'
import { i18n } from '../plugins/i18n'
import { serializeParams } from '../utils/genericUtils.js'

export default {
  namespaced: true,
  state: {
    alerts: [],
  },
  mutations: {
    updateAlerts(state, payload) {
      state.alerts = payload.alerts
    },
  },
  actions: {
    deleteImage(context, id) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + '/employee/web/deleteImage',
          method: 'DELETE',
          params: { id },
        })
          .then((response) => {
            const user = context.rootState.user
            if (user.id === id) {
              const { idImageStorage, imageStorage, img, ...rest } = user
              context.commit(
                'updateUser',
                {
                  user: { ...rest },
                },
                {
                  root: true,
                }
              )
            }
            resolve(response)
          })
          .catch(reject)
      })
    },
    getProfile({ commit }) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + '/employee/web/getEmployee',
          data: {},
          method: 'GET',
        })
          .then((response) => {
            commit(
              'updateUser',
              {
                user: response.data.entity,
              },
              {
                root: true,
              }
            )
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    updateProfile({ commit }, obj) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + '/employee/web/update',
          data: obj,
          method: 'PUT',
        })
          .then((response) => {
            if (response.data.status) {
              commit(
                'updateUser',
                {
                  user: response.data.entity,
                },
                {
                  root: true,
                }
              )
              resolve(response)
            } else {
              reject(response)
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    getSchoolStats({ commit }, id) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + '/employee/web/schoolstats?id=' + id,
          method: 'GET',
        })
          .then((response) => {
            commit(
              'updateSchoolStats',
              {
                schoolStats: response.data.entity,
              },
              {
                root: true,
              }
            )
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    checkConfiguration({ commit, rootGetters }) {
      commit(
        'resetCountActivities',
        {},
        {
          root: true,
        }
      )
      var alerts = []
      var countActivities = 0

      commit(
        'activity/updateConfOptions',
        {
          index: 0,
          index2: 0,
          check: !rootGetters.getSchoolStats.doors == 0,
        },
        {
          root: true,
        }
      )
      commit(
        'activity/updateConfOptions',
        {
          index: 1,
          index2: 1,
          check: !rootGetters.getSchoolStats.doors == 0,
        },
        {
          root: true,
        }
      )

      commit(
        'activity/updateConfOptions',
        {
          index: 1,
          index2: 1,
          check: !rootGetters.getSchoolStats.zones == 0,
        },
        {
          root: true,
        }
      )

      commit(
        'activity/updateConfOptions',
        {
          index: 2,
          index2: 0,
          check: !rootGetters.getSchoolStats.numAdmins == 0,
        },
        {
          root: true,
        }
      )

      commit(
        'activity/updateConfOptions',
        {
          index: 4,
          index2: 0,
          check: !rootGetters.getSchoolStats.numParents == 0,
        },
        {
          root: true,
        }
      )
      commit(
        'activity/updateConfOptions',
        {
          index: 4,
          index2: 1,
          check: !(
            !rootGetters.getSchoolStats.numParents == 0 &&
            rootGetters.getSchoolStats.numFamiliars == 0
          ),
        },
        {
          root: true,
        }
      )
      commit(
        'activity/updateConfOptions',
        {
          index: 4,
          index2: 2,
          check: !(
            rootGetters.getSchoolStats.numParents == 0 &&
            rootGetters.getSchoolStats.SPLinkkflag
          ),
        },
        {
          root: true,
        }
      )

      commit(
        'activity/updateConfOptions',
        {
          index: 1,
          index2: 0,
          check: !rootGetters.getSchoolStats.numLevels == 0,
        },
        {
          root: true,
        }
      )
      commit(
        'activity/updateConfOptions',
        {
          index: 1,
          index2: 1,
          check: !rootGetters.getSchoolStats.numLevels == 0,
        },
        {
          root: true,
        }
      )
      commit(
        'activity/updateConfOptions',
        {
          index: 1,
          index2: 2,
          check: !(
            rootGetters.getSchoolStats.numLevels == 0 &&
            rootGetters.getSchoolStats.nGroups == 0
          ),
        },
        {
          root: true,
        }
      )

      commit(
        'activity/updateConfOptions',
        {
          index: 3,
          index2: 0,
          check: !rootGetters.getSchoolStats.numStudents == 0,
        },
        {
          root: true,
        }
      )
      commit(
        'activity/updateConfOptions',
        {
          index: 3,
          index2: 1,
          check: !(
            rootGetters.getSchoolStats.numStudents == 0 &&
            rootGetters.getSchoolStats.SPLinkkflag
          ),
        },
        {
          root: true,
        }
      )

      commit(
        'activity/updateConfOptions',
        {
          index: 5,
          index2: 0,
          check: !rootGetters.getSchoolStats.nUds == 0,
        },
        {
          root: true,
        }
      )

      commit(
        'activity/updateConfOptions',
        {
          index: 5,
          index2: 0,
          check: !rootGetters.getSchoolStats.numEmployees == 0,
        },
        {
          root: true,
        }
      )

      if (rootGetters.getSchoolStats.doors == 0) {
        countActivities++
        countActivities++
      } else if (rootGetters.getSchoolStats.zones == 0) {
        countActivities++
      }
      if (rootGetters.getSchoolStats.numAdmins == 0) {
        countActivities++
      }
      if (rootGetters.getSchoolStats.numParents == 0) {
        countActivities++
      } else {
        if (!rootGetters.getSchoolStats.SPLinkkflag) {
          countActivities++
        }
        if (rootGetters.getSchoolStats.numFamiliars == 0) {
          countActivities++
        }
      }
      if (rootGetters.getSchoolStats.numLevels == 0) {
        countActivities++
      } else if (rootGetters.getSchoolStats.nGroups == 0) {
        countActivities++
      }
      if (rootGetters.getSchoolStats.numStudents == 0) {
        countActivities++
      } else if (!rootGetters.getSchoolStats.SPLinkkflag) {
        countActivities++
      }
      if (rootGetters.getSchoolStats.nUds == 0) {
        countActivities++
      }
      if (rootGetters.getSchoolStats.numEmployees == 0) {
        countActivities++
      }
      // if (countActivities > 0) {
      //   alerts.push({
      //     text: i18n.t('activityCentre.initConfigMessage'),
      //     go: 'initialConfig'
      //   });
      // }
      if (rootGetters.getSchoolStats.nParentsStudents > 0) {
        alerts.push({
          text: i18n
            .t('activityCentre.tutorsUnlink')
            .replace('%d', rootGetters.getSchoolStats.nParentsStudents),
          go: 'Tutores',
        })
        countActivities++
      }
      if (rootGetters.getSchoolStats.nStudentsParents > 0) {
        alerts.push({
          text: i18n
            .t('activityCentre.studentsUnlink')
            .replace('%d', rootGetters.getSchoolStats.nStudentsParents),
          go: 'Alumnos',
        })
        countActivities++
      }

      commit(
        'activity/updateAlerts',
        {
          alerts: alerts,
        },
        {
          root: true,
        }
      )

      commit(
        'updateCountActivities',
        {
          count: countActivities,
        },
        {
          root: true,
        }
      )
    },
    getEmployees(_, filters) {
      return axios({
        url: `${
          process.env.VUE_APP_URL
        }/employee/web/getbybranch${serializeParams(filters)}`,
        method: 'GET',
      })
    },
    getTools() {
      return axios({
        url: process.env.VUE_APP_URL + '/employee/web/tool',
        method: 'GET',
      })
    },
    createEmployee({ rootGetters }, obj) {
      return new Promise((resolve, reject) => {
        axios({
          url:
            process.env.VUE_APP_URL +
            '/employee/web/create?id=' +
            rootGetters.getBranch.id,
          data: obj,
          method: 'POST',
        })
          .then((response) => {
            if (response.data.status) {
              resolve(response)
            }
            if (response.data.code == 1009) {
              response.statusText = 'Correo repetido'
            }
            reject(response)
          })
          .catch((error) => {
            error.statusText = 'Ups ocurrió un error ' + error.status
            reject(error)
          })
      })
    },
    updateEmployee(o, obj) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + '/employee/web/update',
          data: obj,
          method: 'PUT',
        })
          .then((response) => {
            if (response.data.status) {
              resolve(response)
            }
            if (response.data.code == 1009) {
              response.statusText = 'Correo repetido'
            }
            reject(response)
          })
          .catch((error) => {
            error.statusText = 'Ups ocurrió un error ' + error.status
            reject(error)
          })
      })
    },
    deleteEmployee(o, obj) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + '/employee/web/deleteV2',
          data: obj,
          method: 'DELETE',
        })
          .then((response) => {
            if (response) {
              resolve(response)
            }
            reject(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    importColab({ rootGetters }, obj) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + '/employee/web/importEmployees',
          data: obj,
          method: 'POST',
        })
          .then((response) => {
            if (response.data.status) {
              resolve(response)
            }
            reject(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    getIpads({ rootGetters }) {
      return axios({
        url: `${process.env.VUE_APP_URL}/employee/web/getqrsbybranch?id=${rootGetters.getBranch.id}`,
        method: 'GET',
      })
    },
    getAccesses(_) {
      return axios({
        url: `${process.env.VUE_APP_URL}/raspberry/web/hardware`,
        method: 'GET',
      })
    },
    getPermits(o) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + '/employee/web/getpermits',
          method: 'GET',
        })
          .then((response) => {
            if (response.data.status) {
              resolve(response)
            }
            reject(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    genQrCode({ rootGetters }, obj) {
      return axios({
        url: `${process.env.VUE_APP_URL}/employee/web/qrcodegen?id=${rootGetters.getBranch.id}`,
        data: obj,
        method: 'POST',
      })
    },
    updatePermits(_, payload) {
      return axios({
        url: `${process.env.VUE_APP_URL}/employee/web/updatePermits/${payload.deviceId}`,
        method: 'PUT',
        data: payload.body,
      })
    },
    getQR(o, id) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + '/employee/web/getqrsbyid?id=' + id,
          method: 'GET',
        })
          .then((response) => {
            if (response.data.status) {
              resolve(response)
            }
            reject(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    deleteNewQr(o, id) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + '/employee/web/deleteempqr?id=' + id,
          method: 'DELETE',
        })
          .then((response) => {
            if (response.data.status) {
              resolve(response)
            }
            reject(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    unLinkQR(o, id) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + '/logout/webadminqrlogout?id=' + id,
          method: 'PUT',
        })
          .then((response) => {
            if (response.data.status) {
              resolve(response)
            }
            reject(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    sendEmployee(o, id) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + '/employee/web/sendMail?id=' + id,
          method: 'POST',
        })
          .then((response) => {
            if (response.data.status) {
              resolve(response)
            }
            reject(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },

    getColaboratorByBranchToCsv(_, filters) {
      return axios({
        headers: {
          Accept: 'application/octet-stream',
          'Content-Type': 'application/octet-stream',
        },
        url: `${
          process.env.VUE_APP_URL
        }/employee/web/exportCollaboratorsXlsx${serializeParams(filters)}`,
        method: 'GET',
        responseType: 'blob',
      })
    },
    getQrImgCollaborator(_, params) {
      return axios({
        headers: {
          accept: 'application/octet-stream',
          responseType: 'blob',
          'content-type': 'application/octet-stream',
        },
        url: `
          ${
            process.env.VUE_APP_URL
          }/employee/web/downloadImageQr${serializeParams(params)}`,
        method: 'GET',
        responseType: 'blob',
        'content-type': 'application/octet-stream',
        accept: 'application/octet-stream',
        'Access-Control-Allow-Origin': '*',
        userType: 'W',
      })
    },

    blockQR(o, obj) {
      return new Promise((resolve, reject) => {
        axios({
          url:
            process.env.VUE_APP_URL + '/employee/web/' + obj.id + '/toggleQR',
          data: {
            reason: obj.reason,
            disable: obj.disable,
            start: obj.start,
            end: obj.endDate,
          },
          method: 'PUT',
        })
          .then((response) => {
            if (response.data.status) {
              resolve(response)
            } else {
              reject(response)
            }
          })
          .catch((error) => {
            delete axios.defaults.headers.common['accept']
            delete axios.defaults.headers.common['responseType']
            delete axios.defaults.headers.common['content-type']
            reject(error)
          })
      })
    },
    getProfileSA({ commit }) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + '/sa/web',
          data: {},
          method: 'GET',
        })
          .then((response) => {
            commit(
              'updateUserSA',
              {
                user_sa: response.data,
              },
              {
                root: true,
              }
            )
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    massiveUploadUpgrade(_, data) {
      return axios({
        url: `${process.env.VUE_APP_URL}/collaboratorupgrade/web`,
        method: 'POST',
        data,
      })
    },
    massiveUploadIsLocked(_) {
      return axios({
        url: `${process.env.VUE_APP_URL}/collaboratorupgrade/web/isLocked`,
        method: 'GET',
      })
    },
    getItemsMassiveUpload(_, [idFileUpgrade, params]) {
      return axios({
        url: `${process.env.VUE_APP_URL}/collaboratorupgrade/web/${idFileUpgrade}/collaborators`,
        method: 'GET',
        params: params,
      })
    },
    massiveUploadUpdateItem(_, [collaboratorId, data]) {
      return axios({
        url: `${process.env.VUE_APP_URL}/collaboratorupgrade/web/collaborator/${collaboratorId}`,
        method: 'PUT',
        data,
      })
    },
    massiveUploadComplete(_, data) {
      return axios({
        url: `${process.env.VUE_APP_URL}/collaboratorupgrade/web/completeUpgrade`,
        method: 'POST',
        data,
      })
    },
    massiveUploadStatistics(_, idFileUpgrade) {
      return axios({
        url: `${process.env.VUE_APP_URL}/collaboratorupgrade/web/${idFileUpgrade}/statistics`,
        method: 'GET',
      })
    },
    getQr(_, filters) {
      return axios({
        headers: {
          Accept: 'application/octet-stream',
          'Content-Type': 'application/octet-stream',
        },
        url: `${process.env.VUE_APP_URL}/employee/web/qr${serializeParams(
          filters
        )}`,
        method: 'GET',
        responseType: 'blob',
      })
    },
  },
}
